(function ($) {


    $('.product-detail-gallery-lightbox-zoom-target').on('click', function (e) {
        const $img = $(this);
        const $container = $img.closest('.panzoom');
        const isZoomed = $img.hasClass('zoomed');


        const containerRatio = $container[0].clientWidth / $container[0].clientHeight;
        const imageRatio = $img[0].naturalWidth / $img[0].naturalHeight;

        // Reset zoom u všech
        $('.product-detail-gallery-lightbox-zoom-target').removeClass('zoomed').removeClass('-wide').css('transform', '');

        if (isZoomed) return;

        // Kliknutí ve výchozí výšce obrázku
        const offset = $img.offset();
        const clickX = e.pageX - offset.left;
        const clickY = e.pageY - offset.top;
        const clickRatioX = clickX / $img.width();
        const clickRatioY = clickY / $img.height();


        $img.addClass('zoomed');
        const isWide = imageRatio > containerRatio;
        if (isWide) {
            $img.addClass('-wide');
        }

        requestAnimationFrame(() => {
            const newWidth = $img.outerWidth();
            const newHeight = $img.outerHeight();
            const containerWidth = $container.width();
            const containerHeight = $container.height();


            if (isWide) {
                // horizontální scroll
                const targetOffsetX = (newWidth * clickRatioX) - (containerWidth / 2);
                const maxOffsetX = Math.max(newWidth - containerWidth, 0);
                const scrollTargetX = Math.min(Math.max(targetOffsetX, 0), maxOffsetX);
                $container.scrollLeft(scrollTargetX);
            } else {
                // vertikální scroll
                const targetOffsetY = (newHeight * clickRatioY) - (containerHeight / 2);
                const maxOffsetY = Math.max(newHeight - containerHeight, 0);
                const scrollTargetY = Math.min(Math.max(targetOffsetY, 0), maxOffsetY);
                $container.scrollTop(scrollTargetY);
            }

        });

    });

})(jQuery);